var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPdf2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_520897",
    "data-name": "Path 520897",
    d: "M4.808,16.625H4.371V14h.437a1.313,1.313,0,0,1,0,2.625ZM10.491,14h.437a.873.873,0,0,1,.874.875v3.5a.873.873,0,0,1-.874.875h-.437ZM12.239,0V7a1.747,1.747,0,0,0,1.748,1.75h6.994V24.5a3.5,3.5,0,0,1-3.5,3.5H3.5A3.5,3.5,0,0,1,0,24.5V3.5A3.5,3.5,0,0,1,3.5,0ZM3.5,12.25a.873.873,0,0,0-.874.875v7a.874.874,0,1,0,1.748,0v-1.75h.437a3.063,3.063,0,0,0,0-6.125Zm5.245,7.875A.873.873,0,0,0,9.616,21h1.311a2.628,2.628,0,0,0,2.623-2.625v-3.5a2.628,2.628,0,0,0-2.623-2.625H9.616a.873.873,0,0,0-.874.875Zm6.994-7.875a.873.873,0,0,0-.874.875v7a.874.874,0,1,0,1.748,0V17.5h1.748a.875.875,0,0,0,0-1.75H16.61V14h1.748a.875.875,0,0,0,0-1.75ZM13.988,0l6.994,7H13.988Z",
    fill: "#b141f8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_520898",
    "data-name": "Path 520898",
    d: "M0,0H28V28H0Z",
    fill: "none"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf2);
export default __webpack_public_path__ + "static/media/pdf2.6a03a7835c4274e809566f25a77e231d.svg";
export { ForwardRef as ReactComponent };